/** Lighten (amt>0) or darken (amt<0) a hex color, amt in -1..1. */
export function shade(hex: string, amt: number): string {
  const n = parseInt(hex.slice(1), 16);
  let r = (n >> 16) & 0xff;
  let g = (n >> 8) & 0xff;
  let b = n & 0xff;
  const f = (v: number) => Math.round(amt >= 0 ? v + (255 - v) * amt : v * (1 + amt));
  r = Math.min(255, Math.max(0, f(r)));
  g = Math.min(255, Math.max(0, f(g)));
  b = Math.min(255, Math.max(0, f(b)));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}
